export default __webpack_public_path__ + "static/media/chatIcon.72d40be5.svg";